import { useState } from "react";
import { MapPin, Search } from "react-feather";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  Button,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Row,
} from "reactstrap";

const SearchJob = () => {
  const [jobQuery, setJobQuery] = useState("");
  const [location, setLocation] = useState("");
const history=useHistory()
const handleSearch = (e) => {
  e.preventDefault();
  history.push(`/jobs-opening-list`, {
      isSearch: true,
      filter:{ fld_title: jobQuery,
        fld_type: jobQuery,
        fld_city: location,
        fld_state: location}
  });
};


  return (
    <div className="my-4">
      <Container>
        <h4 className="text-center mb-3 section-title text-dark">
          Find Field Audit
        </h4>
        <Form onSubmit={handleSearch} className="shadow-sm rounded p-4">
          <Row className="g-3 align-items-center">
            <Col md={5}>
              <FormGroup className="mb-2 md-mb-0 position-relative">
                <div className="position-relative">
                  <Search
                    size={20}
                    className="position-absolute text-muted"
                    style={{
                      top: "50%",
                      left: "10px",
                      transform: "translateY(-50%)",
                    }}
                  />
                  <Input
                    type="text"
                    placeholder="Job type (Part/Full time, gigs)"
                    value={jobQuery}
                    onChange={(e) => setJobQuery(e.target.value)}
                    style={{ paddingLeft: "40px" }} // Adds space for the icon
                  />
                </div>
              </FormGroup>
            </Col>
            <Col md={5}>
              <FormGroup className="mb-2 md-mb-0 position-relative">
                <div className="position-relative">
                  <MapPin
                    size={20}
                    className="position-absolute text-muted"
                    style={{
                      top: "50%",
                      left: "10px",
                      transform: "translateY(-50%)",
                    }}
                  />
                  <Input
                    type="text"
                    placeholder="City, State"
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                    style={{ paddingLeft: "40px" }} // Adds space for the icon
                  />
                </div>
              </FormGroup>
            </Col>
            <Col md={2}>
              <Button
                className="btns mb-1"
                style={{ border: "none", textTransform: "capitalize" }}
              >
                Search
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    </div>
  );
};

export default SearchJob;
